<template>
  <div class="transition">
    <v-card :loading="loading" class="pt-2" style="min-height: 140px" shaped elevation="10">
      <div class="flex justify-end">
        <div class="w-1/6 mr-2 mb-2">
          <InputCompetenciaDate
            v-model="form.data_competencia"
            position="is-bottom-right"
          />
        </div>
      </div>

      <v-row>
        <v-col md="4" cols="12">
          <div class="text-center">
            <div class="text-md text-neutral-600">Liberado para Gestora</div>
            <div class="font-bold text-primary-600 text-4xl">
              {{ dataSet.gestoras ? dataSet.gestoras : "--" }}
            </div>
          </div>
        </v-col>
        <v-col md="4" cols="12">
          <div class="text-center">
            <div class="text-md text-neutral-600">Novas empresas</div>
            <div class="font-bold text-primary-600 text-4xl">
              {{ dataSet.new ? dataSet.new : "--" }}
            </div>
          </div>
        </v-col>
        <v-col md="4" cols="12">
          <div class="text-center">
            <div class="text-md text-neutral-600">Empresas finalizadas</div>
            <div class="font-bold text-primary-600 text-4xl">
              {{ dataSet.finished ? dataSet.finished : "--" }}
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="flex justify-between">
        <div
          class="text-sm whitespace-no-wrap text-neutral-500 bg-white m-3"
          style=""
        >
          {{ moment().locale("pt-br").format("MMM [de] YYYY") }}
        </div>
        <div>
          <Lynx-Button
            text="Relatorio"
            class="mb-4"
            @click.native="gerarRelatorio()"
            size="small"
            icon-size="3"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { quantityNewCompaniesRequest } from "@/services/requests/charts";
import moment from "moment";
import InputCompetenciaDate from "@/components/helpers/InputCompetenciaDate";

export default {
  name: "NewCompaniesCountStats",
  components: {
    InputCompetenciaDate,
  },
  data() {
    return {
      dataSet: {},
      form: {
        data_competencia: new Date().toISOString().split("T")[0],
      },
      loading: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    "form.data_competencia"(val) {
      this.fetchData();
    },
  },
  methods: {
    moment,
    async fetchData() {
      this.loading = true;
      await quantityNewCompaniesRequest(this.form).then(
        (response) => (this.dataSet = response.data)
      );
      this.loading = false;
    },
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/dashboard/quantity-new-companies-excel/?token=${this.$store.getters.getToken}&data_competencia=${this.form.data_competencia}`,
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
</style>
